import { html, property } from 'lit-element';
import { KatLitElement, register } from '../../shared/base';

import baseStyles from '../../shared/base/base.lit.scss';

/**
 * @component {kat-flag} KatalFlag A flag component will allow you to display a countries flag, more countries will be coming
 * @guideline Do Use correct size, default is small
 * @guideline Do Use flags with caution. Some may present localization issues.
 * @guideline Dont Don't use a flag as shorthand for a language selection. Some countries have multiple languages.
 * @example Small-USA-Flag {"country": "us", "size":"small"}
 * @example Large-USA-Flag {"country": "us", "size":"large"}
 * @example Large-Colombia-Flag {"country": "co", "size":"large"}
 * @status Production
 * @theme flo
 */
@register('kat-flag')
export class KatFlag extends KatLitElement {
  /**
   * The size of the flag - Default is small
   * @enum {value} tiny Tiny
   * @enum {value} small Small - Default
   * @enum {value} large Large
   */
  @property()
  size?: string;

  /**
   * The two letter ISO code of the country - Default is "us"
   * @enum {value} ae United Arab Emirates
   * @enum {value} at Austria
   * @enum {value} au Australia
   * @enum {value} be Belgium
   * @enum {value} bg Bulgaria
   * @enum {value} br Brazil
   * @enum {value} ca Canada
   * @enum {value} ch Switzerland
   * @enum {value} cl Chile
   * @enum {value} cn China
   * @enum {value} co Colombia
   * @enum {value} cz Czech Republic
   * @enum {value} de Germany
   * @enum {value} dk Denmark
   * @enum {value} do Dominican Republic
   * @enum {value} eg Egypt
   * @enum {value} es Spain
   * @enum {value} eu European Union
   * @enum {value} fi Finland
   * @enum {value} fr France
   * @enum {value} gb Great Britain
   * @enum {value} hk Hong Kong
   * @enum {value} hu Hungary
   * @enum {value} ie Ireland
   * @enum {value} il Israel
   * @enum {value} in India
   * @enum {value} it Italy
   * @enum {value} jp Japan
   * @enum {value} kp North Korea
   * @enum {value} kr South Korea
   * @enum {value} ma Morocco
   * @enum {value} mx Mexico
   * @enum {value} ng Nigeria
   * @enum {value} nl Netherlands
   * @enum {value} no Norway
   * @enum {value} nz New Zealand
   * @enum {value} ph Philippines
   * @enum {value} pl Poland
   * @enum {value} pt Portugal
   * @enum {value} ro Romania
   * @enum {value} ru Russia
   * @enum {value} sa Saudi Arabia
   * @enum {value} se Sweden
   * @enum {value} sg Singapore
   * @enum {value} tr Turkey
   * @enum {value} uk United Kingdom
   * @enum {value} us United States
   * @enum {value} za South Africa
   */
  @property()
  country: string;

  static get styles() {
    return [baseStyles];
  }

  render() {
    const name = this.country ? this.country.toLowerCase() : 'us';
    const size = this.size || 'small';
    return html`
      <kat-icon class="icon" size=${size} name=${`flag-${name}`}></kat-icon>
    `;
  }
}
